import { render, staticRenderFns } from "./AiQuestionImprove.vue?vue&type=template&id=7dc08619"
import script from "./AiQuestionImprove.vue?vue&type=script&lang=ts"
export * from "./AiQuestionImprove.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports